<template>
    <div v-if="show">
        <div class="box" :class="{
            'warning' : nearlyExpired(expiry),
            'danger' : expired(expiry),
            'active': selected,
            'selectable' : selectable,
        }" @click="choose">
            <div class="box-inner box-copy" >
                <template v-if="!deleting">
                    <div class="row card-top" v-if="editable">
                        <div class="col-md-6">
                                <template v-if="nearlyExpired(expiry)">
                                    <span class="expires">Nearly Expired!</span>
                                </template>
                                <template v-if="expired(expiry)">
                                    <span class="expired">Expired!</span>
                                </template>
                        </div>
                        <div class="col-md-6 text-right">
                            <a href="#" @click.prevent="deleting = true">Delete</a>
                        </div>
                    </div>
                    <div class="chip"></div>
                    <div class="number">
                        <div class="number-break" v-for="i in 3" :key="i">
                            <span class="asterix">****</span>
                        </div>
                        <div class="number-break">
                            {{ lastFour }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="brand">
                                <img :src="icon" width="50px">
                            </div>
                        </div>
                        <div class="col-md-6 text-right">
                            <div class="expiry">
                                <strong>EXP:</strong> {{ expiry|date('M/YY') }}
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <label>Enter the last four digits to confirm</label>
                    <div class="form-group">
                        <input class="form-control" type="number" v-model="lastFourConfirmed">
                    </div>
                    <button @click="cancel" class="btn btn-sm btn-grey">Cancel</button>
                    <button @click="deletePayment" class="btn btn-sm btn-danger" :disabled="lastFourConfirmed != lastFour">Delete</button>
                </template>
            </div>
        </div>
        <div v-if="expired(expiry)" class="text-danger">
            This card will not show up in the checkout
        </div>
    </div>
</template>

<script>
    import ReusablePayments from '../../Services/Account/ReusablePayments';

    export default {
        props: ['type', 'lastFour', 'id', 'provider', 'expiry', 'editable', 'selectable', 'selected', 'token'],
        computed: {
            icon() {
                return '/img/orbital/payment-icons/' + this.type.toLowerCase() +'-icon.png';
            }
        },
        data() {
            return {
                deleting: false,
                show: true,
                lastFourConfirmed: null,
            }
        },
        methods: {
            choose() {
                this.$emit('chosen', this.token);
            },
            cancel() {
                this.deleting = false;
                this.lastFourConfirmed = null;
            },
            deletePayment() {
                return;
            },
            getDiff(to) {
                const now = moment();
                const expiry = moment(to);
                return moment.duration(expiry.diff(now));
            },
            expired(date) {
                const diff = this.getDiff(date);
                return diff.asDays() < 1 && diff.asHours() < 1 && diff.asMinutes() < 1 && diff.asSeconds() < 1;
            },
            nearlyExpired(date) {
                const diff = this.getDiff(date);

                if (!this.editable) {
                    return false;
                }
                return diff.asDays() < 1 && (diff.asHours() > 1 || diff.asSeconds() > 1);
            },
            deletePayment() {
                ReusablePayments.delete(this.id).then(response => {
                    this.show = false;
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    .box {
        margin-bottom:5px;
        &.warning {
            background: #FFC845;
            background: -webkit-gradient(linear, left top, left bottom, color-stop(50%, #FFC845), color-stop(51%, #C3921D));
            background: linear-gradient(to bottom, #FFC845 50%, #C3921D 51%);
        }
        &.danger {
            background: #FFC845;
            background: -webkit-gradient(linear, left top, left bottom, color-stop(50%, #FF4545), color-stop(51%, #C31D1D));
            background: linear-gradient(to bottom, #FF4545 50%, #C31D1D 51%);
        }
        &.active {
            background: #4ACC48;
            background: -webkit-gradient(linear, left top, left bottom, color-stop(50%, #4ACC48), color-stop(51%, #00A108));
            background: linear-gradient(to bottom, #4ACC48 50%, #00A108 51%);
        }
        &.selectable {
            cursor: pointer;
        }
    }
    .expired {
        color: #FF4545;
    }
    .expires {
        color: #C3921D;
    }
    .chip {
        width:40px;
        border-radius:4px;
        height:25px;
        background-color:#D9CA9D;
        margin-bottom:5px;
    }
    .card-top {
        margin-bottom:10px;
    }
    .bank {
        text-align: right;
        font-size:1.25em;
        line-height: 1;
        font-weight:500;
        text-transform:uppercase;
        color:#ebebeb;
    }
    .number {
        font-size:1.5em;
        margin-bottom:8px;
        .number-break {
            display: inline-block;
            width:24%;
            box-sizing:border-box;
        }
        .asterix {
            vertical-align:sub;
            letter-spacing: 4px;
        }
    }
    .expiry {
        padding-top:5px;
        font-size:.875em;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Account/AccountReusablePayment.vue